import React from "react";

const FeatureNewsIllustration = ({ variant = "aurora" }) => {
  const tones = {
    aurora: { paper: "#FFF4EA", line: "#FFD0A8", accent: "#FF7100", soft: "#FFB347", check: "#22C55E" },
    editorial: { paper: "#F7F4F1", line: "#E8D9CC", accent: "#C2410C", soft: "#E7B48A", check: "#0F766E" },
    midnight: { paper: "#EAF3FF", line: "#C9DDF8", accent: "#3B82F6", soft: "#93C5FD", check: "#22C55E" },
    pulse: { paper: "#ECFDF5", line: "#BBF7D0", accent: "#14B8A6", soft: "#5EEAD4", check: "#F59E0B" },
  };
  const color = tones[variant] || tones.aurora;

  return (
    <svg
      className="feature-news-illustration"
      viewBox="0 0 180 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <ellipse cx="96" cy="108" rx="62" ry="8" fill={color.accent} opacity="0.12" />
      <rect x="58" y="38" width="92" height="58" rx="8" fill="#fff" stroke={color.line} strokeWidth="2" />
      <rect x="64" y="44" width="80" height="40" rx="4" fill={color.paper} />
      <rect x="70" y="50" width="28" height="6" rx="3" fill={color.soft} />
      <rect x="70" y="60" width="44" height="5" rx="2.5" fill={color.line} />
      <rect x="70" y="69" width="36" height="5" rx="2.5" fill={color.paper} />
      <rect x="70" y="96" width="68" height="6" rx="3" fill={color.line} />
      <rect x="18" y="46" width="36" height="36" rx="8" fill={color.accent} />
      <path d="M30 58h12M36 52v12" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
      <circle cx="148" cy="28" r="16" fill={color.check} />
      <path d="M142 28h12M148 22v12" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" />
      <rect x="128" y="62" width="28" height="22" rx="6" fill={color.soft} />
      <path d="M136 78V68h12v10" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

export default FeatureNewsIllustration;
